import React, { useEffect, useMemo, useState } from "react";
import {
  ModalHeader,
  ModalBody,
  useDisclosure,
  Input,
} from "@nextui-org/react";
import {
  AccountOfStore,
  FooterFilterMobile,
  LoaderCustom,
  MachineOfStore,
  ModelNext,
} from "../../components";
import { useGetAllStoreApi } from "../../hooks";
import { TStore } from "../../types";
import { useAccountOfStore, useAccountStore, useAuthStore } from "../../store";
import { Button, Modal, Space, Table } from "antd";
import toast from "react-hot-toast";
import { useCreateStoreApi } from "../../hooks/store/useCreateStoreApi";
import { MdDelete } from "react-icons/md";
import { HiPencilAlt } from "react-icons/hi";
import { MdAutorenew } from "react-icons/md";
import { useUpdateStoreApi } from "../../hooks/store/useUpdateStoreApi";
import { useDeleteStoreApi } from "../../hooks/store/useDeleteStoreApi";
import { useNavigate } from "react-router-dom";
import path from "../../ultils/path";
import FooterMobile from "../../components/common/FooterMobile";
import { FaUser } from "react-icons/fa";
import { CgSmartHomeWashMachine } from "react-icons/cg";
import { ROLE } from "../../ultils/constants";
import { useUpdateFrameMachineApi } from "../../hooks/machine/useUpdateFrameMachineApi";

export default function StorePage() {
  // state
  const [isLoader, setIsLoader] = useState(false);
  const [searchTerm, setSearchTerm] = useState(""); // Added for search term
  const [isModalOpenUpdate, setIsModalOpenUpdate] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [storeSelect, setStoreSelect] = useState<any>();
  const [isUpdateFrameModalOpen, setIsUpdateFrameModalOpen] = useState(false);
  const [updateFrameKey, setUpdateFrameKey] = useState("");

  // state info create
  const [infoStore, setInfoStore] = useState<any>({
    grade: "",
    groupId: 0,
    groupPass: 0,
    groupName: 0,
  });

  const [infoUpdateStore, setInfoUpdateStore] = useState<any>({
    grade: "",
    groupId: 0,
    groupPass: 0,
    groupName: 0,
  });

  const navigate = useNavigate();
  const { token } = useAuthStore();
  const { info } = useAccountStore();
  const isAdmin = info?.role === ROLE.ROLE_ADMIN;
  useEffect(() => {
    if (!token) {
      navigate(path.SIGN_IN);
    }
  }, []);

  const { mutate: $createNewStore, isPending: isPendingCreate } =
    useCreateStoreApi();
  const { mutate: $updateStore } = useUpdateStoreApi();
  const { mutate: $updateFrameMachine } = useUpdateFrameMachineApi();
  const { mutate: $deleteStore } = useDeleteStoreApi();

  const { setStoreId } = useAccountOfStore();

  const showModal = () => {
    setIsModalOpen(true);
  };

  const showUpdateFrameModal = () => {
    setUpdateFrameKey("");
    setIsUpdateFrameModalOpen(true);
  };

  const handleOkUpdateFrame = () => {
    if (!updateFrameKey?.trim()) {
      toast.error("Key is required");
      return;
    }
    $updateFrameMachine(
      { key: updateFrameKey.trim() },
      {
        onSuccess: (res: any) => {
          if (res?.code === 200) {
            toast.success(res?.message || "Update success");
          } else {
            toast.error(res?.message || "Update failure");
          }
          setIsUpdateFrameModalOpen(false);
          setUpdateFrameKey("");
        },
        onError: () => {
          toast.error("Update failure");
        },
      }
    );
  };

  const handleDelete = async (id: any) => {
    $deleteStore(id, {
      onSuccess: () => {
        toast.success("Delete Store Successfully");
        return;
      },
      onError: () => {
        toast.error("Delete Store Failure");
        return;
      },
    });
  };

  const handleOk = async () => {
    $createNewStore(infoStore, {
      onSuccess: () => {
        toast.success("Create Store success");
        setIsModalOpen(false);
        return;
      },
      onError: () => {
        toast.error("Create Store failure");
        setIsModalOpen(false);
        return;
      },
    });
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  // api get store
  const { allStore, isLoading } = useGetAllStoreApi(true);

  // useEffect for loader
  useEffect(() => {
    setIsLoader(true);
    setTimeout(() => {
      setIsLoader(false);
    }, 200);
  }, []);

  const storeRows = useMemo(() => {
    const data = allStore?.data ?? [];
    return data.map((item: TStore) => ({
      key: item?.groupId,
      id: item?.groupId,
      grade: item?.grade,
      groupPass: item?.groupPass,
      groupName: item?.groupName,
      groupPhone: item?.groupPhone,
      tokenKey: item?.tokenKey,
      groupId: item?.groupId,
    }));
  }, [allStore?.data]);

  const filteredUsers = useMemo(() => {
    const term = searchTerm.toLowerCase();
    if (!term) return storeRows;
    return storeRows.filter((store: any) =>
      String(store?.groupName ?? "")
        .toLowerCase()
        .includes(term)
    );
  }, [searchTerm, storeRows]);

  const handleOkUpdate = async () => {
    $updateStore(infoUpdateStore, {
      onSuccess: () => {
        toast.success("Update Store Success");
        setIsModalOpenUpdate(false);
        return;
      },
      onError: () => {
        toast.error("Update Store Failure");
        setIsModalOpenUpdate(false);
        return;
      },
    });
  };

  // State model
  const {
    isOpen: isOpenDetailMember,
    onOpen: onOpenDetailMember,
    onOpenChange: onOpenChangeDetailMember,
  } = useDisclosure();

  const {
    isOpen: isOpenDetailMachine,
    onOpen: onOpenDetailMachine,
    onOpenChange: onOpenChangeDetailMachine,
  } = useDisclosure();

  const handleCancelUpdate = () => {
    setIsModalOpenUpdate(false);
  };

  const handleUpdateStoreAdmin = (item: any) => {
    if (!isAdmin) return;
    $updateFrameMachine(
      {
        storeId: item?.groupId ?? item?.id,
      },
      {
        onSuccess: (res: any) => {
          toast.success(res?.message || "Update Store Success");
        },
        onError: () => {
          toast.error("Update Store Failure");
        },
      }
    );
  };

  const columns = [
    {
      title: "LEVEL",
      dataIndex: "grade",
      key: "grade",
    },
    {
      title: "PASSWORD",
      dataIndex: "groupPass",
      key: "groupPass",
    },
    {
      title: "STORE NAME",
      dataIndex: "groupName",
      key: "groupName",
    },
    {
      title: "STORE ID",
      dataIndex: "groupId",
      key: "groupId",
    },
    // {
    //   title: "groupPhone",
    //   dataIndex: "groupPhone",
    //   key: "groupPhone",
    // },
    {
      title: "MANAGE",
      dataIndex: "",
      key: "infomation",
      render: (_: any, item: any) => (
        <div className="flex items-center xl:gap-3 gap-2">
          <div
            onClick={() => {
              setStoreId(item?.id);
              navigate(path.MACHINE_OF_STORE);
            }}
            className="cursor-pointer hover:underline font-medium bg-blue-500 bg-opacity-20 h-full flex justify-center items-center p-[6px] rounded-md"
          >
            <CgSmartHomeWashMachine className="xl:text-2xl text-xl text-blue-500 cursor-pointer" />
          </div>
          <div
            onClick={() => {
              onOpenDetailMember();
              setStoreId(item?.id);
              setStoreSelect(item);
            }}
            className="cursor-pointer hover:underline font-medium bg-blue-500 bg-opacity-20 h-full flex justify-center items-center p-[6px] rounded-md"
          >
            <FaUser className="xl:text-2xl text-xl text-blue-500 cursor-pointer" />
          </div>
          <div
            className="cursor-pointer hover:underline font-medium bg-blue-500 bg-opacity-20 h-full flex justify-center items-center p-[6px] rounded-md"
            onClick={() => {
              setInfoUpdateStore({
                grade: item?.grade,
                groupId: item?.groupId,
                groupPass: item?.groupPass,
                groupName: item?.groupName,
              });
              setIsModalOpenUpdate(true);
            }}
          >
            <HiPencilAlt className="xl:text-2xl text-xl text-blue-500 cursor-pointer"></HiPencilAlt>
          </div>
          {isAdmin && (
            <div
              className="cursor-pointer font-medium bg-photo-time-pink-main bg-opacity-15 h-full flex justify-center items-center p-[6px] rounded-md"
              onClick={() => handleUpdateStoreAdmin(item)}
            >
              <MdAutorenew className="xl:text-2xl text-xl text-photo-time-pink-main cursor-pointer" />
            </div>
          )}
        </div>
      ),
    },
    // {
    //   title: "Action",
    //   dataIndex: "",
    //   key: "action",
    //   render: (_: any, record: any) => (
    //     <Space size="large">
    //       <div
    //         className="cursor-pointer hover:underline font-medium bg-blue-500 bg-opacity-20 h-full flex justify-center items-center p-[6px] rounded-md"
    //         onClick={() => {
    //           setInfoUpdateStore({
    //             grade: record?.grade,
    //             groupId: record?.groupId,
    //             groupPass: record?.groupPass,
    //             groupName: record?.groupName,
    //           });
    //           setIsModalOpenUpdate(true);
    //         }}
    //       >
    //         <HiPencilAlt className="xl:text-2xl text-xl text-blue-500 cursor-pointer"></HiPencilAlt>
    //       </div>
    //       {/* <div
    //         className="cursor-pointer hover:underline font-medium bg-red-500 bg-opacity-20 h-full flex justify-center items-center p-[6px] rounded-md"
    //         onClick={() => {
    //           handleDelete(record?.groupId);
    //         }}
    //       >
    //         <MdDelete className="xl:text-2xl text-xl text-red-500 cursor-pointer" />
    //       </div> */}
    //     </Space>
    //   ),
    // },
  ];

  return (
    <>
      {/* member of store */}
      <ModelNext
        isOpen={isOpenDetailMember}
        onOpen={onOpenDetailMember}
        onOpenChange={onOpenChangeDetailMember}
      >
        <ModalHeader className="flex flex-col gap-1 lg:text-base text-base max-sm:text-sm text-photo-time-pink-light">
          Member of Store ({storeSelect?.groupName})
        </ModalHeader>
        <ModalBody>
          <AccountOfStore onOpenDetailMember={onOpenDetailMember} />
        </ModalBody>
      </ModelNext>

      {/* Create new store */}
      <Modal
        okButtonProps={{ style: { backgroundColor: "black" } }}
        title="Create New Store"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <div className="flex flex-col gap-4">
          <Input
            onChange={(e) => {
              setInfoStore({ ...infoStore, grade: e.target.value });
            }}
            placeholder="grade"
          />
          <Input
            onChange={(e) => {
              setInfoStore({ ...infoStore, groupId: e.target.value });
            }}
            placeholder="groupId"
          />
          <Input
            onChange={(e) => {
              setInfoStore({ ...infoStore, groupPass: e.target.value });
            }}
            placeholder="groupPass"
          />
          <Input
            onChange={(e) => {
              setInfoStore({ ...infoStore, groupName: e.target.value });
            }}
            placeholder="groupName"
          />
          <div className="flex items-center my-2">
            {isPendingCreate && (
              <span className="font-semibold">Loading...</span>
            )}
          </div>
        </div>
      </Modal>

      {/* Update frame by key */}
      <Modal
        okButtonProps={{ style: { backgroundColor: "black" } }}
        title="Update"
        open={isUpdateFrameModalOpen}
        onOk={handleOkUpdateFrame}
        onCancel={() => setIsUpdateFrameModalOpen(false)}
      >
        <div className="flex flex-col gap-3">
          <Input
            type="text"
            placeholder="Key"
            value={updateFrameKey}
            onChange={(e) => setUpdateFrameKey(e.target.value)}
          />
        </div>
      </Modal>

      {/* Update store */}
      <Modal
        okButtonProps={{ style: { backgroundColor: "black" } }}
        title="Update Store"
        open={isModalOpenUpdate}
        onOk={handleOkUpdate}
        onCancel={handleCancelUpdate}
      >
        <div className="flex flex-col gap-4">
          <Input
            onChange={(e) => {
              setInfoUpdateStore((init: any) => ({
                ...init,
                grade: e.target.value,
              }));
            }}
            defaultValue={infoUpdateStore?.grade}
            placeholder="grade"
          />
          <Input
            onChange={(e) => {
              setInfoUpdateStore((init: any) => ({
                ...init,
                groupPass: e.target.value,
              }));
            }}
            placeholder="groupPass"
            defaultValue={infoUpdateStore?.groupPass}
          />
          <Input
            onChange={(e) => {
              setInfoUpdateStore((init: any) => ({
                ...init,
                groupName: e.target.value,
              }));
            }}
            placeholder="groupName"
            defaultValue={infoUpdateStore?.groupName}
          />
        </div>
      </Modal>

      {/* machine */}
      <ModelNext
        isOpen={isOpenDetailMachine}
        onOpen={onOpenDetailMachine}
        onOpenChange={onOpenChangeDetailMachine}
      >
        <ModalHeader className="flex flex-col gap-1 lg:text-base text-base text-photo-time-pink-light">
          Machine of Store
        </ModalHeader>
        <ModalBody>
          <MachineOfStore />
        </ModalBody>
      </ModelNext>

      {isLoader && <LoaderCustom />}
      <div className="w-[100%] p-[16px] md:pb-2 font-semibold text-ok-travel-green mb-2 max-md:mb-0 border-b-[1.5px] md:mb-4">
        <div className="flex max-lg:flex-col lg:items-center max-lg:mt-2 justify-between xl:mb-7 lg:mb-5 mb-4 max-md:flex max-md:flex-row max-md:items-center">
          <span className="uppercase xl:text-xl text-base font-semibold text-gray-600">
            MANAGE STORE
          </span>
          <div>
            <div className="flex items-center gap-2">
              <Button
                onClick={showModal}
                color="default"
                variant="solid"
                size="middle"
              >
                <span className=" max-lg:text-sm max-sm:text-xs">
                  CREATE STORE
                </span>
              </Button>
              {isAdmin && (
                <Button
                  onClick={showUpdateFrameModal}
                  color="default"
                  variant="solid"
                  size="middle"
                >
                  <span className=" max-lg:text-sm max-sm:text-xs">UPDATE FRAME</span>
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="mt-4 px-[16px] md:px-[0px]">
        <Input
          placeholder="Search by group name..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="mb-4 max-w-md"
          startContent={
            <svg
              className="w-5 h-5 text-gray-500"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              />
            </svg>
          }
        />
        <Table
          dataSource={filteredUsers}
          columns={columns}
          rowKey={(record: any) => record?.groupId ?? record?.id}
          pagination={false}
          className="md:block hidden"
        />
      </div>
      <div className="md:hidden flex flex-col px-[8px] xl:gap-6 gap-4">
        {filteredUsers &&
          filteredUsers?.map((item: any, index: number) => (
            <div
              key={index}
              className="flex flex-col w-full bg-white border-[1px] border-gray-200 sm:min-h-[20vh] max-sm:min-h-[20vh]"
            >
              <div className="w-full sm:h-[10vh] max-sm:h-[8vh] bg-gray-200 flex items-center justify-between sm:p-[12px] p-[10px]">
                <div className="uppercase font-semibold text-gray-600 max-sm:text-sm">
                  {item?.groupName}
                </div>
                <div className="flex items-center gap-1 h-full">
                  {/* <div
                    className="cursor-pointer hover:underline font-medium bg-blue-500 bg-opacity-20 h-full min-w-12 flex justify-center items-center p-[6px] rounded-md"
                    onClick={() => {
                      setInfoUpdateStore({
                        grade: item?.grade,
                        groupId: item?.groupId,
                        groupPass: item?.groupPass,
                        groupName: item?.groupName,
                      });
                      setIsModalOpenUpdate(true);
                    }}
                  >
                    <HiPencilAlt className="text-3xl text-blue-700 cursor-pointer" />
                  </div>
                  <div
                    className="cursor-pointer hover:underline font-medium bg-red-500 bg-opacity-20 h-full min-w-12 flex justify-center items-center p-[6px] rounded-md"
                    onClick={() => {
                      handleDelete(item?.groupId);
                    }}
                  >
                    <MdDelete className="text-3xl text-red-500 cursor-pointer" />
                  </div> */}
                  <div
                    onClick={() => {
                      setStoreId(item?.id);
                      navigate(path.MACHINE_OF_STORE);
                    }}
                    className="cursor-pointer hover:underline font-medium bg-blue-500 bg-opacity-20 h-full flex justify-center items-center p-[6px] rounded-md"
                  >
                    <CgSmartHomeWashMachine className="xl:text-2xl text-xl max-sm:text-sm text-blue-500 cursor-pointer" />
                  </div>
                  <div
                    onClick={() => {
                      onOpenDetailMember();
                      setStoreId(item?.id);
                      setStoreSelect(item);
                    }}
                    className="cursor-pointer hover:underline font-medium bg-blue-500 bg-opacity-20 h-full flex justify-center items-center p-[6px] rounded-md"
                  >
                    <FaUser className="xl:text-2xl text-xl max-sm:text-sm text-blue-500 cursor-pointer" />
                  </div>
                  <div
                    className="cursor-pointer hover:underline font-medium bg-blue-500 bg-opacity-20 h-full flex justify-center items-center p-[6px] rounded-md"
                    onClick={() => {
                      setInfoUpdateStore({
                        grade: item?.grade,
                        groupId: item?.groupId,
                        groupPass: item?.groupPass,
                        groupName: item?.groupName,
                      });
                      setIsModalOpenUpdate(true);
                    }}
                  >
                    <HiPencilAlt className="xl:text-2xl text-xl max-sm:text-sm text-blue-500 cursor-pointer"></HiPencilAlt>
                  </div>
                  {isAdmin && (
                    <div
                      className="cursor-pointer font-medium bg-photo-time-pink-main bg-opacity-15 h-full flex justify-center items-center p-[6px] rounded-md"
                      onClick={() => handleUpdateStoreAdmin(item)}
                      title="Update store (admin)"
                    >
                      <MdAutorenew className="xl:text-2xl text-xl max-sm:text-sm text-photo-time-pink-main cursor-pointer" />
                    </div>
                  )}
                </div>
              </div>
              <div className="sm:p-[12px] p-[10px] w-full h-auto flex flex-col sm:gap-5 max-sm:gap-4">
                <div className="flex items-center sm:gap-6 gap-5">
                  <div className="w-[30%] font-bold text-gray-600">grade:</div>
                  <div className="uppercase text-gray-700">{item?.grade}</div>
                </div>
                <div className="flex items-center sm:gap-6 gap-5">
                  <div className="w-[30%] font-bold text-gray-600">
                    groupId:
                  </div>
                  <div className="uppercase text-gray-700">{item?.groupId}</div>
                </div>
                <div className="flex items-center sm:gap-6 gap-5">
                  <div className="w-[30%] font-bold text-gray-600">
                    groupPass:
                  </div>
                  <div className="uppercase text-gray-700">
                    {item?.groupPass}
                  </div>
                </div>
                <div className="flex items-center sm:gap-6 gap-5">
                  <div className="w-[30%] font-bold text-gray-600">
                    groupName:
                  </div>
                  <div className="uppercase text-gray-700">
                    {item?.groupName}
                  </div>
                </div>
                {/* <div className="flex items-center sm:gap-6 gap-5">
                  <div className="w-[30%] font-bold text-gray-600">
                    machine of store:
                  </div>
                  <div
                    onClick={() => {
                      setStoreId(item?.id);
                      navigate(path.MACHINE_OF_STORE);
                    }}
                    className="uppercase text-gray-700 font-bold underline"
                  >
                    detail
                  </div>
                </div> */}
              </div>
            </div>
          ))}
      </div>
      {/* <FooterMobile /> */}
      <FooterFilterMobile />
    </>
  );
}
